import { render, staticRenderFns } from "./view.html?vue&type=template&id=141d1c8a&scoped=true&"
import script from "./script.js?vue&type=script&lang=js&"
export * from "./script.js?vue&type=script&lang=js&"
import style0 from "./homestyle.less?vue&type=style&index=0&id=141d1c8a&lang=less&scoped=true&"
import style1 from "./homestyle_mobile.less?vue&type=style&index=1&id=141d1c8a&lang=less&scoped=true&"
import style2 from "./otherstyle.less?vue&type=style&index=2&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "141d1c8a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('141d1c8a')) {
      api.createRecord('141d1c8a', component.options)
    } else {
      api.reload('141d1c8a', component.options)
    }
    module.hot.accept("./view.html?vue&type=template&id=141d1c8a&scoped=true&", function () {
      api.rerender('141d1c8a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/box/share/index.vue"
export default component.exports